import { render, staticRenderFns } from "./EditarPesoAlturaPrescricao.vue?vue&type=template&id=663150f4&"
import script from "./EditarPesoAlturaPrescricao.vue?vue&type=script&lang=js&"
export * from "./EditarPesoAlturaPrescricao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports